<template>
  <Page title="Data Kontrak">
    <Grid
      id="table-kontrak"
      :datagrid.sync="datagrid"
      dbref="DOC.SelKontrakList"
      :dbparams.sync="filters"
      class="dense"
      :preHead="true"
      :disabled="true"
      :height="'calc(100vh - 120px)'"
      :doRebind="gridRebind"
      :hasChild="true"
      :columns="[
        {
          name: 'Paket',
          value: 'NamaPaket',
          class: 'bold',
          width: '250px',
        },
        {
          name: 'Kontrak',
          value: 'Kontraktor',
          width: '200px',
        },
        {
          name: 'Jangka Waktu',
          value: 'JangkaWaktu',
          class: 'center',
        },
        {
          name: 'Sdh / Blm Dibayar',
          value: 'Dibayar',
          class: 'right',
        },
        {
          name: 'Keterangan',
          value: 'StatusTermin',
        },
        {
          name: '',
          value: 'Action',
        },
        {
          name: '',
          value: 'Edit',
        },
      ]"
      @row-click="rowClick"
    >
      <template v-slot:pre-head>
        <div style="display:flex;" class="pre-head">
          <div style="flex:2; font-size: 14px;">
            <Select
              dbref="MST.SelBalai"
              width="500px"
              :value.sync="filters.BalaiID"
              @change="gridRebind++"
            />
          </div>
          <v-spacer></v-spacer>
          <v-btn
            small
            color="primary"
            style="margin-right:10px;"
            @click="OpenEdit($event, 0)"
          >
            <v-icon left>mdi-plus</v-icon>
            TAMBAH KONTRAK
          </v-btn>
        </div>
      </template>
      <template v-slot:child>
        <div
          style="background: #f3f3f3; box-shadow: inset 0 0 5px rgb(0 0 0 / 30%); "
        >
          <div
            v-if="!childData.length"
            style="width: 100%; padding:6px 10px; text-align:center"
          >
            Tidak Ada Data
          </div>
          <div
            v-else
            style="display:flex; font-size:11px; border-bottom:1px solid #e3e3e3;"
            v-for="(c, idx) in childData"
            :key="idx"
          >
            <div style="padding:6px 10px; width:275px;"></div>
            <div style="padding:6px 10px; width:210px; font-weight:bold;">
              {{ c.TerminDesc }}
            </div>
            <div style="padding:6px 10px; width:116px; text-align:center;">
              {{ c.TglSelesai | format }}
            </div>
            <div
              style="padding:6px 10px; width:140px; text-align:right;  font-weight:500;"
            >
              {{ c.NilaiTermin | format }}
            </div>
          </div>
        </div>
      </template>
      <template v-slot:row-Kontraktor="{ row }">
        <div style="font-weight:500;">{{ row.NoKontrak }}</div>
        <div style="width:190px; overflow: hidden; white-space:nowrap">
          {{ row.NamaKontraktor }}
        </div>
      </template>
      <template v-slot:row-JangkaWaktu="{ row }">
        <div>{{ row.TglMulai | format }}</div>
        <div>{{ row.TglSelesai | format }}</div>
      </template>
      <template v-slot:row-Dibayar="{ row }">
        <div>{{ row.SudahBayar | format }}</div>
        <div style="font-weight: bold; color:#da4f49;">
          {{ row.BelumBayar | format }}
        </div>
      </template>
      <template v-slot:row-StatusTermin="{ row }">
        <div
          v-html="row.StatusTermin"
          v-if="row.StatusTermin != 'SUDAH LUNAS'"
        ></div>
        <div v-else-if="row.TglFHO" style="font-weight:bold">
          [{{
            row.TglFHO == row.TglSelesai
              ? 'PHO'
              : row.TglFHO == row.TglPemeliharaan
              ? 'FHO'
              : 'INS'
          }}] {{ row.TglFHO | format }}
        </div>
        <div v-else>
          SUDAH LUNAS
        </div>
      </template>
      <template v-slot:row-Action="{ row }">
        <MenuButton
          v-if="getActionButtonText(row) == 'BELUM FHO'"
          :menu="['Sudah FHO', 'Putus Kontrak']"
          @item-click="UpdStatusAkhir($event, row)"
        >
          <template v-slot="{ on }">
            <v-btn
              rounded
              small
              dark
              :color="getActionButtonColor(row)"
              v-on="on"
            >
              {{ getActionButtonText(row) }}
            </v-btn>
          </template>
        </MenuButton>
        <v-btn
          v-else
          rounded
          small
          dark
          v-tooltip="{
            content: (row.Tooltip || '').replace(/,/g, '<br/>'),
            html: true,
          }"
          :outlined="
            ['LUNAS', 'SUDAH FHO', 'PUTUS'].includes(getActionButtonText(row))
          "
          :color="getActionButtonColor(row)"
          @click="doAction($event, row)"
        >
          {{ getActionButtonText(row) }}
        </v-btn>
      </template>
      <template v-slot:row-Edit="{ row }">
        <v-btn
          fab
          x-small
          color="error"
          v-tooltip="'Edit Kontrak'"
          @click="OpenEdit($event, row.KontrakID)"
        >
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
      </template>
    </Grid>
    <v-btn
      class="subpage-close"
      color="error"
      fab
      dark
      v-show="showSubpage"
      @click="closeSubpage"
    >
      <v-icon>mdi-close</v-icon>
    </v-btn>
    <div class="subpage-right" v-show="showSubpage">
      <KontrakDet
        :kontrakId="kontrakId"
        :balaiId="filters.BalaiID"
        v-if="showKontrakDet"
        @close="closeSubpage"
      />
      <UploadDoc
        :kontrakId="kontrakId"
        v-if="showUploadDoc"
        @close="showUploadDoc = false"
      />
    </div>
    <Modal title="Detail SP2D" :show.sync="showSP2D" @submit="SaveSP2D">
      <div class="form-inline" style="width:300px;">
        <Input type="text" label="No. SP2D" :value.sync="sp2d.NoSP2D" />
        <DatePicker label="Tgl SP2D" :value.sync="sp2d.TglSP2D"></DatePicker>
      </div>
    </Modal>
  </Page>
</template>
<script>
import DatePicker from '../../components/Forms/DatePicker.vue'
import KontrakDet from './KontrakDet'
import UploadDoc from './UploadDoc'

export default {
  components: {
    KontrakDet,
    UploadDoc,
    DatePicker,
  },
  data: () => ({
    tglNow: new Date(),
    datagrid: [],
    gridRebind: 1,
    childData: [],
    sp2d: {},
    filters: {
      BalaiID: localStorage.getItem('balaiId'),
      Tahun: localStorage.getItem('tahun'),
    },
    kontrakId: 0,
    showKontrakDet: false,
    showUploadDoc: false,
    showSP2D: false,
  }),
  computed: {
    showSubpage() {
      return this.showKontrakDet || this.showUploadDoc
    },
  },
  mounted() {
    if (this.$route.query._KontrakID) {
      this.kontrakId = this.$route.query._KontrakID
      this.showKontrakDet = true
    }
  },
  methods: {
    getActionButtonText(row) {
      switch (row.btnActionClass) {
        case 'act-paid':
          if (row.TglPemeliharaan < this.tglNow && !row.StatusAkhir)
            return 'BELUM FHO'
          else if (row.StatusAkhir == 'sudah_fho') return 'SUDAH FHO'
          else if (row.StatusAkhir == 'putus_kontrak') return 'PUTUS'
          else return 'LUNAS'
        case 'act-pay':
          return 'INPUT SP2D'
        case 'act-completion':
          return 'VERIFIKASI DINAS'
        case 'act-approval':
          return 'VERIFIKASI'
        default:
          return 'UPLOAD DOC'
      }
    },
    getActionButtonColor(row) {
      switch (row.btnActionClass) {
        case 'act-paid':
          if (row.TglPemeliharaan < this.tglNow && !row.StatusAkhir)
            return 'warning'
          else if (row.StatusAkhir == 'putus_kontrak') return 'error'
          else return 'success'
        case 'act-pay':
          return 'blue-grey'
        case 'act-completion':
          return 'secondary'
        case 'act-approval':
          return '#03A9F4'
        default:
          return 'primary'
      }
    },
    async rowClick(row) {
      this.childData = []
      let ret = await this.$api.call('DOC.SelKontrakTermin', {
        KontrakID: row.KontrakID,
      })
      if (ret.success) {
        this.childData = ret.data
      }
    },
    doAction(evt, row) {
      this.kontrakId = row.KontrakID
      this.termin = row.Termin

      switch (row.btnActionClass) {
        case 'act-paid':
          break
        case 'act-pay':
          this.showSP2D = true
          break
        case 'act-completion':
          this.$router.push(
            `/Main/Dinas/Approval/${row.KontrakID}/${row.Termin}`
          )
          break
        case 'act-approval':
          this.$router.push(
            `/Main/Balai/Approval/${row.KontrakID}/${row.Termin}`
          )
          break
        default:
          this.showUploadDoc = true
          break
      }

      evt.stopPropagation()
    },
    OpenEdit(evt, id) {
      this.kontrakId = id
      this.showKontrakDet = true
      evt.stopPropagation()
    },
    closeSubpage(needRefresh) {
      this.showKontrakDet = false
      this.showUploadDoc = false
      this.kontrakId = 0
      if (needRefresh === true) this.gridRebind++
    },
    async UpdStatusAkhir(evt, row) {
      if (!confirm('Anda yakin?')) return
      let status = {
        'Sudah FHO': 'sudah_fho',
        'Putus Kontrak': 'putus_kontrak',
      }
      await this.$api.call('DOC.UpdStatusAkhir', {
        KontrakID: row.KontrakID,
        StatusAkhir: status[evt],
      })
      // this.showSP2D = false
      this.gridRebind++
    },
    async SaveSP2D() {
      await this.$api.call('DOC.SavTerbitSP2D', {
        ...this.sp2d,
        KontrakID: this.kontrakId,
        Termin: this.termin,
      })
      this.showSP2D = false
      this.gridRebind++
    },
  },
}
</script>
<style lang="scss">
#table-kontrak tbody tr td {
  white-space: normal;
}
.subpage-close {
  position: absolute;
  top: 60px;
  right: calc(70vw + 10px);
  z-index: 11;
}
.subpage-right {
  width: 70vw;
  height: calc(100vh - 50px);
  position: absolute;
  top: 50px;
  right: 0;
  z-index: 1;
  box-shadow: 0 9px 0px 0px white, 0 -9px 0px 0px white, 12px 0 15px -4px white,
    -12px 0 15px -4px rgba(0, 0, 0, 0.3);
}
</style>
